export const BrexIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M12.8457 3.69699C12.1045 4.66797 11.9256 4.99442 11.2099 4.99442H0.5V17.5H4.70045C5.64619 17.5 6.56637 17.048 7.16278 16.303C7.9296 15.2985 8.03184 15.0056 8.77309 15.0056H19.5V2.5H15.274C14.3282 2.5 13.4081 2.95201 12.8457 3.69699ZM16.1686 11.7829H11.687C10.7157 11.7829 9.82108 12.1847 9.22466 12.9548C8.45785 13.9593 8.30448 14.2522 7.58879 14.2522H3.80583V8.25056H8.28744C9.25874 8.25056 10.1534 7.79855 10.7498 7.05357C11.5166 6.08259 11.7211 5.78125 12.4112 5.78125H16.1771V11.7829H16.1686Z"
        fill="currentColor"
      />
    </svg>
  );
};
